export enum NotificationCategory {
    IncidentReviews = 'IncidentReviews',
    NarrativeReviews = 'NarrativeReviews',
    Following = 'Following',
    Subscriptions = 'Subscriptions',
    Assignments = 'Assignments',
    System = 'System',
    Reports = 'Reports',
    Alarms = 'Alarms',
    Integrations = 'Integrations'
}